export enum Skin {
  Classic = 'classic',
  ClassicFacelift = 'classic-facelift',
}
